import { Cell, Grid, Tag, Text } from 'bold-ui'
import { useCondicoesAutorreferidasCardQuery } from 'graphql/hooks.generated'
import React from 'react'

import { ContentCardSection } from '../components/ContentCardSection'

export interface CondicoesAutorreferidasCardProps {
  cidadaoId: ID
}

export function CondicoesAutorreferidasCard(props: CondicoesAutorreferidasCardProps) {
  const { cidadaoId } = props
  const { data, loading } = useCondicoesAutorreferidasCardQuery({
    variables: {
      cidadaoId: cidadaoId,
    },
  })

  return (
    <ContentCardSection isLoading={loading} messageLoading='Carregando dados das condições'>
      <Grid gap={0.5} gapVertical={0.6}>
        {!data?.condicoesAutorreferidas?.length && (
          <Cell>
            <Text component='p' fontStyle='italic'>
              Nenhuma condição informada
            </Text>
          </Cell>
        )}
        {data?.condicoesAutorreferidas
          ?.sort((a, b) => a.descricao.localeCompare(b.descricao))
          .map((condicao) => (
            <Cell style={{ maxWidth: '100%' }} key={condicao.descricao}>
              <Tag type='normal' style={{ maxWidth: '100%' }}>
                <span
                  style={{
                    maxWidth: '100%',
                    whiteSpace: 'normal',
                    display: 'inline-block',
                  }}
                >
                  {condicao.descricao}
                </span>
              </Tag>
            </Cell>
          ))}
      </Grid>
    </ContentCardSection>
  )
}
